import React from 'react';
import { X, LogIn, UserPlus } from 'lucide-react';
import { NETFLIX_COLORS, NETFLIX_SPACING } from '../theme/netflixTheme';

interface AuthSelectionModalProps {
  visible: boolean;
  onClose: () => void;
  onSelectLogin: () => void;
  onSelectSignup: () => void;
}

export function AuthSelectionModal({
  visible,
  onClose,
  onSelectLogin,
  onSelectSignup,
}: AuthSelectionModalProps) {
  if (!visible) return null;

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <button style={closeButtonStyle} onClick={onClose}>
          <X size={24} color={NETFLIX_COLORS.textSecondary} />
        </button>

        <div style={contentStyle}>
          <h2 style={titleStyle}>Faça login para assistir</h2>
          <p style={descriptionStyle}>
            Crie sua conta para acessar o conteúdo completo
          </p>

          <div style={buttonsContainerStyle}>
            <button
              onClick={onSelectLogin}
              style={primaryButtonStyle}
            >
              <LogIn size={18} style={iconMarginStyle} />
              Entrar
            </button>
            <button
              onClick={onSelectSignup}
              style={secondaryButtonStyle}
            >
              <UserPlus size={18} style={iconMarginStyle} />
              Criar Conta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
  backdropFilter: 'blur(4px)',
};

const modalStyle: React.CSSProperties = {
  backgroundColor: NETFLIX_COLORS.surface,
  borderRadius: 12,
  width: '95%',
  maxWidth: 480,
  padding: `${NETFLIX_SPACING.xl * 2}px`,
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${NETFLIX_COLORS.border}`,
  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
  position: 'relative',
};

const closeButtonStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  top: `${NETFLIX_SPACING.lg}px`,
  right: `${NETFLIX_SPACING.lg}px`,
};

const contentStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: `${NETFLIX_SPACING.xl}px`,
  textAlign: 'center',
};

const titleStyle: React.CSSProperties = {
  fontSize: 28,
  fontWeight: '700',
  color: NETFLIX_COLORS.textPrimary,
  margin: 0,
};

const descriptionStyle: React.CSSProperties = {
  fontSize: 16,
  color: NETFLIX_COLORS.textSecondary,
  lineHeight: 1.6,
  margin: 0,
};

const buttonsContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: `${NETFLIX_SPACING.md}px`,
  marginTop: `${NETFLIX_SPACING.lg}px`,
};

const primaryButtonStyle: React.CSSProperties = {
  backgroundColor: NETFLIX_COLORS.primary,
  padding: `${NETFLIX_SPACING.lg}px ${NETFLIX_SPACING.xl}px`,
  borderRadius: 6,
  border: 'none',
  color: NETFLIX_COLORS.white,
  fontSize: 16,
  fontWeight: '700',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: `${NETFLIX_SPACING.md}px`,
  transition: 'all 0.2s ease',
};

const secondaryButtonStyle: React.CSSProperties = {
  backgroundColor: NETFLIX_COLORS.background,
  padding: `${NETFLIX_SPACING.lg}px ${NETFLIX_SPACING.xl}px`,
  borderRadius: 6,
  border: `2px solid ${NETFLIX_COLORS.primary}`,
  color: NETFLIX_COLORS.primary,
  fontSize: 16,
  fontWeight: '700',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: `${NETFLIX_SPACING.md}px`,
  transition: 'all 0.2s ease',
};

const iconMarginStyle: React.CSSProperties = {
  marginRight: 4,
};
